export default class EditActivityController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    months,
    activity,
    ActivityService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.months = months;
    this.ActivityService = ActivityService;
    this.activity = activity;
  }

  cancel() {
    this.$mdDialog.cancel();
  }

  save(form) {
    if (form.$invalid) {
      return false;
    }

    this.ActivityService.edit(this.activity)
      .then(() => {
        this.$mdDialog.hide(this.activity.month);
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Pomyślnie edytowano zajęcie')
            .position('bottom right')
            .hideDelay(3000)
        );
      }).catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }
}
